import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _dec, _class, _descriptor;
import { equal } from "@ember/object/computed";
import RestModel from "discourse/models/rest";
export const CREATED = 0;
export const TRANSITIONED_TO = 1;
export const EDITED = 2;
let ReviewableHistory = (_dec = equal("reviewable_history_type", CREATED), (_class = class ReviewableHistory extends RestModel {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "created", _descriptor, this);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "created", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { ReviewableHistory as default };